import { useEffect, useState } from 'react'
import React from 'react';
import './styles/OddInfo.css';
import { ReactComponent as SwitchDiagram } from './assets/odd.svg';
// Nota: Asegúrate de tener la imagen del diagrama en tu carpeta de assets
// import diagramImage from './assets/diagrama-switch.png';

const InfoContadores = (props) => {
   const info={
    'up':{
        title:'Dispositivos totales en servicio',
       info: "El estado <strong>UP</strong> indica que el dispositivo está operando correctamente, manteniendo una conexión estable y respondiendo a las peticiones de red (Ping) sin pérdida de paquetes.",
    ejemplo: "Un <strong>Switch en verde</strong> fluyendo datos hacia sus cámaras indica que toda la infraestructura está configurada correctamente y el servicio está 100% disponible.",
        animacion:<svg viewBox="0 0 240 120" class="w-full h-auto max-width-up-diagram">
    <path d="M120 40 L60 80" stroke-width="2.5" class="line-up active-flow" fill="none" />
    <path d="M120 40 L120 80" stroke-width="2.5" class="line-up active-flow" fill="none" />
    <path d="M120 40 L180 80" stroke-width="2.5" class="line-up active-flow" fill="none" />

    <rect x="90" y="10" width="60" height="30" rx="6" fill="#10b981" class="node-up" />
    <text x="120" y="30" fill="white" font-size="11" font-family="sans-serif" font-weight="bold" text-anchor="middle">SWITCH</text>
    
    <circle cx="120" cy="25" r="15" fill="#10b981" class="ping-pulse" />

    <g transform="translate(40, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#10b981" class="node-up" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C1</text>
    </g>

    <g transform="translate(100, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#10b981" class="node-up" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C2</text>
    </g>

    <g transform="translate(160, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#10b981" class="node-up" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C3</text>
    </g>
</svg>
    },
    'unkonwn':{
        title:'Dispositivos totales Desconocidos',
       info: "El estado <strong>UNKNOWN</strong> ocurre cuando el sistema no puede determinar el estatus real del equipo. Generalmente se debe a errores de configuración, falta de credenciales SNMP o bloqueos de firewall.",
    ejemplo: "Si el equipo responde a ping pero no entrega datos de telemetría, el sistema lo marcará en <span style='color: #94a3b8;'>Gris (Desconocido)</span> hasta que se valide su configuración.",
    animacion:<svg viewBox="0 0 240 120" class="w-full h-auto max-width-unknown-diagram">
    <path d="M120 40 L60 80" stroke-width="2.5" class="line-unknown" fill="none" />
    <path d="M120 40 L120 80" stroke-width="2.5" class="line-unknown" fill="none" />
    <path d="M120 40 L180 80" stroke-width="2.5" class="line-unknown" fill="none" />

    <rect x="90" y="10" width="60" height="30" rx="6" fill="#94a3b8" />
    <text x="120" y="30" fill="white" font-size="11" font-family="sans-serif" font-weight="bold" text-anchor="middle">SWITCH</text>
    
    <g class="anim-unknown-q">
        <circle cx="145" cy="10" r="10" fill="white" stroke="#64748b" stroke-width="2" />
        <text x="145" y="14.5" fill="#64748b" font-size="12" font-family="sans-serif" font-weight="bold" text-anchor="middle">?</text>
    </g>

    <g transform="translate(40, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#94a3b8" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C1</text>
    </g>

    <g transform="translate(100, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#94a3b8" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C2</text>
    </g>

    <g transform="translate(160, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#94a3b8" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C3</text>
    </g>
</svg>
    },
    'down':{
        title:'Dispositivos totales sin conexión',
        info: "Se considera <strong>DOWN</strong> cuando un equipo pierde comunicación total. A diferencia del ODD, este estado se asigna cuando el fallo es individual del dispositivo y no afecta a una cadena de dependencias.",
    ejemplo: "Si una cámara deja de transmitir pero el Switch al que está conectada sigue activo, la cámara está en estado <span class='text-red'>Down</span> por un fallo local (energía, cable dañado o hardware).",
        animacion:<svg viewBox="0 0 240 120" class="w-full h-auto max-width-down-diagram">
    <path d="M120 40 L60 80" stroke-width="2.5" class="anim-line-down" fill="none" />
    <path d="M120 40 L120 80" stroke-width="2.5" class="anim-line-down" fill="none" />
    <path d="M120 40 L180 80" stroke-width="2.5" class="anim-line-down" fill="none" />

    <rect x="90" y="10" width="60" height="30" rx="6" class="anim-switch-down" />
    <text x="120" y="30" fill="white" font-size="11" font-family="sans-serif" font-weight="bold" text-anchor="middle">SWITCH</text>
    
    <g class="anim-alert-down">
        <circle cx="145" cy="10" r="10" fill="white" stroke="#ef4444" stroke-width="2.5" />
        <text x="145" y="14.5" fill="#ef4444" font-size="12" font-family="sans-serif" font-weight="bold" text-anchor="middle">!</text>
    </g>

    <g transform="translate(40, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" class="anim-cam-down" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C1</text>
    </g>

    <g transform="translate(100, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" class="anim-cam-down" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C2</text>
    </g>

    <g transform="translate(160, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" class="anim-cam-down" />
        <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C3</text>
    </g>
</svg>
    },
    'odd':{
        title:'ORIGIN DEVICE DOWN',
        info:'Entre varios dispositivos dependientes, el <strong>ODD</strong> es el equipo principal que origina la falla y provoca que los demás pierdan conexión.',
        ejemplo:' Si tienes un <span className="text-red">Switch (caído)</span> con 4 cámaras conectadas, las cámaras mostrarán un estado <em>"Down" normal</em> por falta de red, pero el Switch es el <strong>ODD</strong> porque es el origen real del problema.',
        animacion:<svg viewBox="0 0 240 120" class="w-full h-auto max-w-[220px]">
                       
                        <path d="M120 40 L60 80" stroke-width="2.5" class="anim-line" fill="none" />
                        <path d="M120 40 L120 80" stroke-width="2.5" class="anim-line" fill="none" />
                        <path d="M120 40 L180 80" stroke-width="2.5" class="anim-line" fill="none" />

                        
                        <rect x="90" y="10" width="60" height="30" rx="6" class="anim-switch" />
                        <text x="120" y="30" fill="white" font-size="11" font-family="sans-serif" font-weight="bold" text-anchor="middle">SWITCH</text>
                        
                        
                        <g class="anim-alert">
                            <circle cx="145" cy="10" r="10" fill="white" stroke="#ef4444" stroke-width="2.5" />
                            <text x="145" y="14.5" fill="#ef4444" font-size="12" font-family="sans-serif" font-weight="bold" text-anchor="middle">!</text>
                        </g>

                        
                        <g transform="translate(40, 80)">
                            <rect x="0" y="0" width="40" height="24" rx="4" class="anim-cam" />
                            <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
                            <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C1</text>
                        </g>

                        <g transform="translate(100, 80)">
                            <rect x="0" y="0" width="40" height="24" rx="4" class="anim-cam" />
                            <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
                            <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C2</text>
                        </g>

                        <g transform="translate(160, 80)">
                            <rect x="0" y="0" width="40" height="24" rx="4" class="anim-cam" />
                            <circle cx="20" cy="12" r="6" fill="#ffffff" opacity="0.25"/>
                            <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C3</text>
                        </g>
                    </svg>
    },
    'exception':{
        title:'Dispositivos totales en Excepción',
        info: "Una <strong>EXCEPCIÓN</strong> representa una interrupción del servicio planeada o ajena a la red. El equipo no tiene un fallo técnico, sino que su inactividad está justificada por un ticket administrativo.",
    ejemplo: "Un host marcado con el icono de <span style='color: #800020;'>MANTTO</span> o <span style='color: #10b981;'>CFE</span> indica que la red está operativa, pero el dispositivo está apagado por trabajos externos o falta de suministro eléctrico.",
        animacion:<svg viewBox="0 0 240 120" class="w-full h-auto max-width-exception-tags-diagram">
    <path d="M120 40 L60 80" stroke-width="2.5" class="line-exception-tag-ok" fill="none" />
    <path d="M120 40 L120 80" stroke-width="2.5" class="line-exception-tag-ok" fill="none" />
    <path d="M120 40 L180 80" stroke-width="2.5" class="line-exception-tag-ok" fill="none" />

    <rect x="90" y="10" width="60" height="30" rx="6" fill="#10b981" />
    <text x="120" y="30" fill="white" font-size="11" font-family="sans-serif" font-weight="bold" text-anchor="middle">SWITCH</text>

    <g transform="translate(40, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#ea80ff" />
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C1</text>
    </g>
    
    <g class="anim-tag-float cfe-tag-group" transform="translate(45, 45)">
        <rect x="0" y="0" width="30" height="20" rx="4" fill="#37f353" class="tag-shadow" />
        <polygon points="15,20 10,28 20,28" fill="#37f353" transform="rotate(180 15 24)" />
        <path d="M15 4 L9 11 H13 L11 16 L17 9 H13 Z" fill="#007411" />
        
    </g>

    <g transform="translate(100, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#ea80ff" class="node-mtto-pulse" />
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C2</text>
    </g>
    
    <g class="anim-tag-float mtto-tag-group" transform="translate(105, 45)">
        <rect x="0" y="0" width="30" height="20" rx="4" fill="#800020" class="tag-shadow" />
        <polygon points="15,20 10,28 20,28" fill="#800020" transform="rotate(180 15 24)" />
        <path d="M12 6 C10 8 11 11 13 12 L11 15 M18 6 C20 8 19 11 17 12 L19 15" stroke="white" stroke-width="1.5" fill="none" />
    </g>
    
    <g transform="translate(160, 80)">
        <rect x="0" y="0" width="40" height="24" rx="4" fill="#10b981" />
        <text x="20" y="16" fill="white" font-size="10" font-family="sans-serif" font-weight="bold" text-anchor="middle">C3</text>
    </g>
</svg>
    }
}
    return(
        <>
        
        <div className="odd-container">
            <p className={"odd-title "+props.tipo}>
       {info[props.tipo].title}
      </p>
      <p className="odd-description" dangerouslySetInnerHTML={{ __html: info[props.tipo].info }}>
       
      </p>

      <div className="odd-card-visual">
        {/* <SwitchDiagram className="odd-image" /> */}
        {info[props.tipo].animacion}
      </div>

      <div className="odd-example-box">
        <span className="odd-badge">EJEMPLO</span>
        <p className="odd-example-text" dangerouslySetInnerHTML={{ __html: info[props.tipo].ejemplo }}>
         
        </p>
      </div>
    </div>
        </>
    )
}

export default InfoContadores
